export class HarriAPI {
    static setRequest(target, request) {
        target.request = request;
    }
    static setRequestWithHeaders(target, request) {
        target.requestWithHeaders = request;
    }
    static setUniqueRequest(target, request) {
        target.uniqueRequest = request;
    }
}
export function harriApi(config = { harri: "APIServers" /* ENDPOINT.CORE */, teamlive: "APIServers" /* ENDPOINT.CORE */ }) {
    return function (target) {
        let scope = {};
        let api = BaseAPI.call(scope);
        let env = environmentsConfig.getEnv().host == "teamcloud" /* APP_HOST.TEAM_SCHEDULE */ ? config.teamlive : config.harri;
        scope.apiUrl = environmentsConfig.get(env);
        target.setRequest(target, api.request);
        target.setRequestWithHeaders(target, api.requestWithHeaders);
        target.setUniqueRequest(target, api.uniqueRequest);
    };
}
//# sourceMappingURL=HarriAPI.js.map